module.exports = __webpack_public_path__ + "static/img/数字化图书馆.d3b67e3b.png";